import { apiClientService } from '.'

const BASE_ACCOUNT_URL = 'Account/'

function setLoginError(error: any, setError: (error: string) => void) {
  if (setError) {
    if (error.response.status >= 400 && error.response.status < 500) setError('error.invalid_login')
    else setError('error.generic')
  }
}
const login = (
  username: string,
  password: string,
  setSuccess: (token: string, refreshToken: string, changeToken: string) => void,
  setError: (error: string) => void,
) => {
  return apiClientService.baseApiCall(
    BASE_ACCOUNT_URL + 'Login',
    'post',
    undefined,
    { username: username, password: password },
    (res) => {
      setSuccess(res.accessToken, res.refreshToken, res.changeToken)
    },
    (error) => setLoginError(error, setError),
  )
}
const loginByMi = (token: string, setSuccess: (data: any) => void, setError: (error: string) => void) => {
  return apiClientService.baseApiCall(
    BASE_ACCOUNT_URL + 'LoginByMi',
    'post',
    { miToken: token },
    undefined,
    (res) => {
      setSuccess(res)
    },
    (error) => setLoginError(error, setError),
  )
}
const changePassword = (
  oldPassword: string,
  newPassword: string,
  changeToken: string | null | undefined,
  setSuccess: (data: any) => void,
  setError: (error: string) => void,
) => {
  return apiClientService.baseApiCall(
    BASE_ACCOUNT_URL + 'ChangePassword',
    'post',
    undefined,
    { oldPassword: oldPassword, newPassword: newPassword, changeToken: changeToken },
    (res) => {
      setSuccess(res)
    },
    (error) => setError(error),
  )
}
const resetPassword = (idUtente: number, userEmail: string, setSuccess: (data: any) => void, setError: (error: string) => void) => {
  return apiClientService.baseApiCall(
    BASE_ACCOUNT_URL + 'RetrievePassword',
    'post',
    undefined,
    { idUtente: idUtente, userEmail: userEmail },
    (res) => {
      setSuccess(res)
    },
    (error) => setError(error),
  )
}
const register = (
  nome: string,
  cognome: string,
  sesso: string,
  codiceFiscale: string,
  dataDiNascita: string,
  comuneDiNascita: string,
  cittadinanza: string,
  tipoProfilo: string,
  email: string,
  telefono: string,
  setSuccess: (data: any) => void,
  setError: (error: string) => void,
) => {
  return apiClientService.baseApiCall(
    BASE_ACCOUNT_URL + 'Register',
    'post',
    undefined,
    {
      nome: nome,
      cognome: cognome,
      sesso: sesso,
      codiceFiscale: codiceFiscale,
      dataDiNascita: dataDiNascita,
      comuneDiNascita: comuneDiNascita,
      cittadinanza: cittadinanza,
      tipoProfilo: tipoProfilo,
      email: email,
      telefono: telefono,
    },
    (res) => {
      setSuccess(res)
    },
    (error) => setError(error),
  )
}
const modifyProfile = (
  profileType: string | undefined,
  phone: string | undefined,
  mail: string | undefined,
  citizenship: string | undefined,
  setSuccess: (data: any) => void,
  setError: (error: string) => void,
) => {
  return apiClientService.baseApiCall(
    BASE_ACCOUNT_URL + 'ModifyProfile',
    'put',
    undefined,
    { tipoProfilo: profileType, telefono: phone, email: mail, cittadinanza: citizenship },
    (res) => {
      setSuccess(res)
    },
    (error) => setError(error),
  )
}
const infoProfile = (setSuccess: (data: any) => void, setError?: (error: any) => void) => {
  return apiClientService.baseApiCall(BASE_ACCOUNT_URL + 'UserInfo', 'get', undefined, undefined, setSuccess, setError)
}

export const profileService = {
  login,
  modifyProfile,
  infoProfile,
  changePassword,
  resetPassword,
  register,
  loginByMi,
}
